import type { NavigationBarItem } from '@tgtg/kit';

// Mirrors how the kit resolves an item's href, so popover rows navigate to the
// same target the bar would have used.
export const toTarget = (to: NavigationBarItem['to']) =>
  typeof to === 'string' ? to : `${to.pathname}${to.search ?? ''}${to.hash ?? ''}`;

// Mirrors the kit's own active check so an item hidden behind "More" highlights
// on the same paths it would have in the bar.
export const isItemActive = (item: NavigationBarItem, pathname: string) =>
  item.isCurrent ??
  (toTarget(item.to) === pathname || !!item.activeForPaths?.some((path) => path.test(pathname)));
